import PropTypes from 'prop-types'
import { Heading } from '../../../../components/ui/Heading'

export default function EvaluationCard({ icon, title, description }) {
  return (
    <div className={'flex flex-col items-center text-center'}>
      <div className='mb-4'>{icon}</div>
      <Heading className={'text-darkGrey'} level={4}>
        {title}
      </Heading>
      <p className='mt-3 text-sm leading-[130%] text-rockGrey'>{description}</p>
    </div>
  )
}

EvaluationCard.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  highlight: PropTypes.bool
}
